import * as actionTypes from 'constants/ActionTypes';

const ports = (state = {
    suggestions: [],
    searchText: '',
    items: [],
    data: [],
    isLoaded: false,
    page: 1,
    onlyChanged: false,
    query: '',
    sort: 'name',
}, action) => {
    switch (action.type) {
    case actionTypes.GET_PORTS.REQUEST:
        return {
            ...state,
            ...action.pagination,
            isLoaded: false,
        };
    case actionTypes.GET_PORTS.SUCCESS: {
        return {
            ...state,
            ...action.data,
            sort: 'name', // change field from backend wrong format
            isLoaded: true,
        };
    }
    case actionTypes.GET_PORTS.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };

    case actionTypes.GET_ALL_PORTS.REQUEST:
        return {
            ...state,
            isLoaded: false,
        };
    case actionTypes.GET_ALL_PORTS.SUCCESS: {
        const temp = new Set();

        const items = action.data.map((port) => {
            const latlng = port.coordinates;

            if (latlng) {
                const key = latlng[0] + '' + latlng[1];
                if (temp.has(key)) {
                    const newLat = latlng[1] + (Math.random() - 0.5) / 1500;
                    const newLng = latlng[0] + (Math.random() - 0.5) / 1500;

                    port.coordinates = [newLng, newLat];
                } else {
                    temp.add(key);
                }
            }

            return {
                ...port,
                isUpdate: false,
                prevState: port,
            };
        });

        return {
            ...state,
            items,
            isLoaded: true,
        };
    }
    case actionTypes.GET_ALL_PORTS.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };
    case actionTypes.SEARCH_PORT:
        return {
            ...state,
            searchText: action.search,
        };
    case actionTypes.SAVE_PORT: {
        const items = state.items.map((item) => {
            if (item._id === action.item._id) {
                return {
                    ...item,
                    isUpdate: true,
                };
            }

            return item;
        });

        return {
            ...state,
            items,
        };
    }
    case actionTypes.UPDATE_PORT_SUGGESTIONS: {
        return {
            ...state,
            suggestions: action.suggestions,
        };
    }
    case actionTypes.UPDATE_PORT_ALT.REQUEST:
        return {
            ...state,
        };
    case actionTypes.UPDATE_PORT_ALT.SUCCESS: {
        const items = state.items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...action.item,
                    prevState: action.item,
                    isUpdate: false,
                };
            }

            return item;
        });

        return {
            ...state,
            items,
        };
    }
    case actionTypes.UPDATE_PORT_ALT.FAILURE: {
        const items = state.items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...item,
                    isUpdate: true,
                    errors: action.errors,
                };
            }

            return item;
        });

        return {
            ...state,
            items,
        };
    }
    default:
        return state;
    }
};

export default ports;



// WEBPACK FOOTER //
// ./app/reducers/regions/ports.js